import type { SoftwareComment } from "@/types";
import RatingStars from "@/components/base/RatingStars";

export default function CommentSection({ comments }: { comments: SoftwareComment[] }) {
  const avg = comments.reduce((acc, c) => acc + c.rating, 0) / (comments.length || 1);

  return (
    <div>
      <div className="flex items-center gap-3 mb-5 bg-background-100 rounded-lg border border-background-200 p-4">
        <div className="text-center">
          <p className="font-heading text-2xl font-bold text-foreground-950">{avg.toFixed(1)}</p>
          <RatingStars value={avg} showValue={false} />
        </div>
        <div className="text-sm text-foreground-600">
          综合 {comments.length} 条示例评价
          <p className="text-xs text-secondary-500 mt-1">评论内容为演示数据，仅用于展示评论区效果</p>
        </div>
      </div>

      <ul className="space-y-4">
        {comments.map((c) => (
          <li key={c.id} className="flex gap-3.5">
            <div className="w-10 h-10 rounded-full overflow-hidden bg-background-100 border border-background-200 shrink-0">
              <img src={c.avatar} alt={`${c.user} 头像`} title={`${c.user} 的评论`} className="w-full h-full object-cover object-top" />
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2.5 flex-wrap">
                <span className="text-sm font-medium text-foreground-900">{c.user}</span>
                <RatingStars value={c.rating} showValue={false} />
                <span className="text-xs text-secondary-400">{c.date}</span>
              </div>
              <p className="mt-1.5 text-sm text-foreground-600 leading-relaxed">{c.content}</p>
            </div>
          </li>
        ))}
      </ul>

      <div className="mt-5 bg-background-100 rounded-lg border border-background-200 p-4">
        <textarea
          disabled
          rows={3}
          placeholder="评论功能为体验演示，暂不支持发布内容"
          className="w-full bg-background-50 rounded-md border border-background-200 p-3 text-sm text-secondary-400 resize-none cursor-not-allowed"
        ></textarea>
        <div className="mt-2 flex justify-end">
          <button
            type="button"
            disabled
            className="h-9 px-4 text-sm rounded-md bg-secondary-200 text-secondary-500 cursor-not-allowed whitespace-nowrap"
          >
            演示模式
          </button>
        </div>
      </div>
    </div>
  );
}